import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";

import styles from "../DownloadReport.module.scss";
import DropdownButton from "../../../../../components/DropdownButton/DropdownButton";
import { Menu, Tooltip, Button } from "antd";

const TagsField = ({ tooltipTitle, disabled, selectedTag, setSelectedTag }) => {
	const [fieldTouched, setFieldTouched] = useState(false);
	const [placeholder, setPlacegolder] = useState("Тег счётчика");
	const tags = useSelector((store) => store.meterStore.tags);
	const selectedTagName = useMemo(() => {
		if (selectedTag && tags.length) {
			return tags?.find((tag) => tag.id === selectedTag)?.name;
		}
	}, [tags, selectedTag]);
	const overlay = useMemo(() => {
		return (
			<Menu onClick={() => setFieldTouched(true)}>
				<Menu.Item onClick={() => setSelectedTag()} key={"no-tag"}>
					Без тега
				</Menu.Item>
				{tags.map((tag) => {
					return (
						<Menu.Item onClick={() => setSelectedTag(tag.id)} key={tag.id}>
							{tag.name}
						</Menu.Item>
					);
				})}
			</Menu>
		);
	}, [tags]);
	useEffect(() => {
		if (fieldTouched) {
			setPlacegolder("Без тега");
		}
	}, [fieldTouched]);
	if (tags?.length === 1) {
		return (
			<Tooltip title={tooltipTitle}>
				<Button
					className={classNames({
						[styles.activeButton]: selectedTag === 1,
					})}
					onClick={() => {
						if (!selectedTag) {
							setSelectedTag(1);
						} else {
							setSelectedTag();
						}
					}}
					disabled={disabled}
				>
					Котельные
				</Button>
			</Tooltip>
		);
	} else {
		return (
			<Tooltip title={tooltipTitle}>
				<DropdownButton
					overlay={overlay}
					text={selectedTagName || placeholder}
					value={selectedTag}
					buttonClassName={
						selectedTag ? styles.activeButton : styles.notActiveDropdown
					}
				/>
			</Tooltip>
		);
	}
};

export default TagsField;
